export default __webpack_public_path__ + "static/media/parent_slide_student_one.5ab376aa.png";